import type {TagColor} from "~/components/tag/tag.styles";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";

/** Label and colours per change type, shared by the change list and its before / after picture. */
export const TAXONOMY_CHANGE_META: Record<m_taxonomy.ChangeType, {
    label: string;
    tag: TagColor;
    /** Theme palette for the picture's highlight; grey when undefined. */
    palette?: 'success' | 'error' | 'info' | 'warning';
}> = {
    added: {label: 'Added', tag: 'success', palette: 'success'},
    removed: {label: 'Deleted', tag: 'error', palette: 'error'},
    renamed: {label: 'Renamed', tag: 'info', palette: 'info'},
    moved: {label: 'Moved', tag: 'warning', palette: 'warning'},
    updated: {label: 'Updated', tag: 'default'},
};
//TODO: merge possibly in the future with taxonomyTreeEdits.ts